<template>
  <v-app>
    <v-main>
      <GLOnigiriClub />
    </v-main>
  </v-app>
</template>

<script>
import GLOnigiriClub from './components/GLOnigiriClub.vue'

export default {
  name: 'App',

  components: {
    GLOnigiriClub,
  },

  data: () => ({
    //
  }),
}
</script>

<style>
/* Google fontsで導入したいfonts から@importのコードを取得 */
@import url('https://fonts.googleapis.com/css2?family=Zen+Maru+Gothic:wght@700&display=swap');

#app {
  /* Google fontsで導入したいfontsからfont-familyを取ってくる */
  font-family: 'Zen Maru Gothic', sans-serif;
  /*
  背景 
  */
  /* background-color: rgb(252, 247, 236); */
  background: url("./assets/bg.png");
  /* background-repeat: no-repeat; */
  background-position: center center;
  background-attachment: fixed;
  /* background-size: cover; */
}
</style>